import { render, staticRenderFns } from "./CustomReportTable.vue?vue&type=template&id=313f0378"
import script from "./CustomReportTable.vue?vue&type=script&lang=js"
export * from "./CustomReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports